import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

const initialState = {
  isAdminLoggedIn: false,
  userAdmin: {}
};

//creates the user slice with the initial state and actions
const usersAdminSlice = createSlice({
  name: "userAdmin",
  initialState,
  reducers: {
    //action creators
    isAdminLoggedIn(state, action) {
      state.isAdminLoggedIn = action.payload;
    },
    setUserAdmin(state, action) {
      state.userAdmin = action.payload;
    },
    logoutAdmin(state, action) {
      Object.assign(state, initialState);
      // localStorage.removeItem("admintoken");
      return;
    },
  }
});

export const { isAdminLoggedIn, setUserAdmin, logoutAdmin} = usersAdminSlice.actions;
export const userAdminReducer = usersAdminSlice.reducer;
